import styled from 'styled-components';

export const StyledIntegrationCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.75rem;
  background: var(--p-color-bg-surface, #ffffff);
  border: 1px solid var(--p-color-border-secondary, #e3e3e3);
  border-radius: var(--p-border-radius-300, 0.75rem);
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: var(--p-color-border, #c9cccf);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .integration-avatar {
    flex: 0 0 64px;
    width: 64px;
    height: 64px;
    aspect-ratio: 1 / 1;
    border-radius: 0.5rem;
    background: var(--p-color-bg-surface-secondary, #f6f6f7);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      aspect-ratio: 1 / 1;
      padding: 0.25rem;
      box-sizing: border-box;
    }
  }

  .integration-content {
    flex: 1 1 auto;
    min-width: 0;
    padding-top: 0.125rem;
  }

  .integration-heading {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.25rem;
  }

  .integration-description {
    margin: 0;
    line-height: 1.45;
    color: var(--p-color-text-secondary, #6d7175);
  }

  .integration-actions {
    flex: 0 0 auto;
    min-width: 13.5rem;
    padding-top: 0.125rem;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 48em) {
    flex-wrap: wrap;
    padding: 0.75rem;

    .integration-content {
      flex-basis: 100%;
      order: 2;
    }

    .integration-actions {
      flex-basis: 100%;
      min-width: 0;
      justify-content: flex-start;
      order: 3;
      margin-top: 0.5rem;

      .Polaris-ButtonGroup {
        flex-wrap: wrap;
      }
    }
  }
`;